import { Dish, MealKit, Menu } from '@fdha/graphql-api-foodops';

export const getOptions = (edges?: { node: Dish | Menu | MealKit }[]) => {
  return (
    edges?.map(({ node }) => ({
      label: node.name,
      id: node.id,
    })) ?? []
  );
};
